<template>
  <div class="flow-img-step" :class="`step-active${stepNum}`">
    <img :src="require('@/assets/flow_step_img.png')" alt="参赛流程">
    <span class="step-line"/>
  </div>
</template>

<script>
export default {
  name: "stepActive",
  props:{
    stepNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
  .flow-img-step {
    width: 768px;
    margin: 0 auto;
    padding: 0px 0 30px;
    position: relative;
    & > img {
      display: block;
      width: 100%;
    }
    &::after {
      display: block;
      content: '';
      width: 236px;
      height: 6px;
      background-color: #a62325;
      position: absolute;
      bottom: 0;
    }
    &.step-active1 {
      &::after {
        left: 0px;
      }
    }
    &.step-active2 {
      &::after {
        left: 268px;
      }
    }
    &.step-active3 {
      &::after {
        left: 532px;
      }
    }
  }
</style>
